export const hasRole = (roles, role) => {
  let rolesArray = roles;
  if (!Array.isArray(roles)) {
    rolesArray = [roles];
  }
  return rolesArray.includes(role);
};
